import { render, staticRenderFns } from "./tailorism.vue?vue&type=template&id=05edf322&scoped=true"
import script from "./tailorism.vue?vue&type=script&lang=js"
export * from "./tailorism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05edf322",
  null
  
)

export default component.exports